import { autoCapitalize } from '@/utils/autoCapitalize'
import { MedicalRecordData } from '@/modules/Telemedicine/pages/MedicalRecord/components/MedicalRecordSearch/MedicalRecordSearch.types'

class MedicalRecordListMapper {
  toDomain(persistenceMedicalRecordlData: MedicalRecordData) {
    return {
      id: persistenceMedicalRecordlData?.appointmentId,
      date: persistenceMedicalRecordlData?.appointmentDate?.split(' ')[0],
      hour: persistenceMedicalRecordlData?.appointmentDate?.split(' ')[1],
      professional: autoCapitalize(persistenceMedicalRecordlData?.name),
      professionalId: persistenceMedicalRecordlData?.professionalId,
      specialty: persistenceMedicalRecordlData?.specialty,
      replaceSpecialty: autoCapitalize(
        persistenceMedicalRecordlData?.councilDescription,
      ),
      specialtyId: persistenceMedicalRecordlData?.specialtyId,
      council: persistenceMedicalRecordlData?.councilType.toUpperCase(),
      councilId: persistenceMedicalRecordlData?.councilId,
      outcome:
        autoCapitalize(
          persistenceMedicalRecordlData?.outcome?.replaceAll('_', ' '),
        ) || '-',
      email: persistenceMedicalRecordlData?.patientEmail,
      status: autoCapitalize(persistenceMedicalRecordlData?.status),
      realizedNewMedicalRecordCrp:
        persistenceMedicalRecordlData?.realizedNewMedicalRecordCrp,
      hasSuccessOutcome: persistenceMedicalRecordlData?.hasSuccessOutcome,
    }
  }
}

export default new MedicalRecordListMapper()
